export const DBNP_MAPPINGS_RESET_STATE = 'DBNP_MAPPINGS_RESET_STATE';
export const DBNP_MAPPINGS_CURRENT_ITEM = 'DBNP_MAPPINGS_CURRENT_ITEM';

export const DBNP_MAPPINGS_REQUEST_LOADING = 'DBNP_MAPPINGS_REQUEST_LOADING';
export const DBNP_MAPPINGS_REQUEST_SUCCESS = 'DBNP_MAPPINGS_REQUEST_SUCCESS';
export const DBNP_MAPPINGS_REQUEST_FAILED = 'DBNP_MAPPINGS_REQUEST_FAILED';

export const DBNP_MAPPINGS_CURRENT_ACTION = 'DBNP_MAPPINGS_CURRENT_ACTION';
export const DBNP_MAPPINGS_RESET_ACTION = 'DBNP_MAPPINGS_RESET_ACTION';